import React, { useEffect, useState } from "react";
import { Dropdown, Table } from "react-bootstrap";
import "./style.scss";
import { getPaymentHistory } from "../../services/paymentAndHistory.service";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

export default function PaymentHistory() {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [paymentList, setPaymentList] = useState([]);
  // State to store the years array
  const [years, setYears] = useState<number[]>([currentYear]);

  const navigate = useNavigate();

  let monthArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleSelect = (year: any) => {
    setSelectedYear(year);
    loadPayments();
  };

  const loadPayments = async () => {
    try {
      const result = await getPaymentHistory(selectedYear);
      if (result.status == 200) {
        if (result?.data?.data) {
          setPaymentList(result?.data?.data);
        }
        if (result?.data?.data.length > 0 && result?.data?.data[0] && result?.data?.data[0].startYear && result?.data?.data[0]?.endYear) {
          const generatedYears = Array.from(
            { length: result?.data?.data[0].endYear - result?.data?.data[0]?.startYear + 1 },
            (_, index) => result?.data?.data[0]?.startYear + index
          );
          setYears([...generatedYears]); // Ensuring the current year is included
        }

      } else if (result.status == 404) {
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.responseMessage);
      }
    }
  };

  useEffect(() => {
    loadPayments();
  }, [selectedYear]);

  const viewPaymentBreakdown = (month: number) => {
    navigate(`/payment-history/month?year=${selectedYear}&month=${month}`);
  };

  return (
    <div className="paymentHistoryPage paymentTable">
      <div className="container">
        <h3>Payments & History</h3>
        <div className="bgFormColor p-4 my-4">
          <div className="yearDropdown">
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                {selectedYear || "Select Year"}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {years.map((year: any) => (
                  <Dropdown.Item key={year} onClick={() => handleSelect(year)}>
                    {year}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="table-responsive">
            <Table className="tableWrapper">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Check-ins</th>
                  <th>No-Show</th>
                  <th>Cancelled classes</th>
                  <th>Total Revenue (in LE)</th>
                  <th>Payment Status / Action</th>
                </tr>
              </thead>

              <tbody>
                {paymentList &&
                  paymentList.length > 0 &&
                  paymentList.map((item: any) => {
                    return (
                      <tr>
                        <td>
                          <span className="underline">
                            {monthArray[item?.month - 1]}
                          </span>
                        </td>
                        <td>{item?.totalCheckins}</td>
                        <td>{item?.noShow}</td>
                        <td>{item?.totalCancelled}</td>
                        <td>{item?.totalRevenue}</td>
                        <td>
                          <div className="d-flex gap-2 align-items-center">
                            <button
                              className="confirmBtn"
                              onClick={() => viewPaymentBreakdown(item?.month)}
                            >
                              View breakdown
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}
